module.exports = __webpack_public_path__ + "static/media/cookies_policy.7f569140.pdf";